import logging from "utils/logging";
import utils from "./firebaseUtils";
import { collection, doc, getDocs, updateDoc, serverTimestamp } from "firebase/firestore";
import {
  FIREBASE_COLLECTION_GAMES,
  FIREBASE_COLLECTION_SUPERLATIVES,
  FIREBASE_FUNCTION_GENERATE_SUPERLATIVES,
  FIREBASE_FUNCTION_SEED_FINALE_SCENARIO,
  SUPERLATIVES_FIELD_CURRENT_INDEX,
  SUPERLATIVES_FIELD_STATUS,
  SUPERLATIVES_FIELD_FINALE_SHOWN_AT,
  SUPERLATIVES_STATUS_FINALE,
} from "./constants";
import { loadModelsForQuerySnapshot } from "./firebaseModels";

const log = logging.getLogger("Provider/Superlatives");

const generateSuperlatives = async (gameId) => {
  const fn = utils.getCallableFunction(FIREBASE_FUNCTION_GENERATE_SUPERLATIVES);
  const result = await fn({ gameId });
  log.debug("Generated superlatives:", result);
  return result;
};

const getSuperlatives = async (gameId) => {
  const ref = collection(
    utils.db(),
    FIREBASE_COLLECTION_GAMES,
    gameId,
    FIREBASE_COLLECTION_SUPERLATIVES
  );
  const snaps = await getDocs(ref);
  return loadModelsForQuerySnapshot(snaps);
};

const updateSuperlativeIndex = async (gameId, index) => {
  const gameRef = doc(utils.db(), FIREBASE_COLLECTION_GAMES, gameId);
  await updateDoc(gameRef, { [SUPERLATIVES_FIELD_CURRENT_INDEX]: index });
};

const markSuperlativesFinale = async (gameId) => {
  const gameRef = doc(utils.db(), FIREBASE_COLLECTION_GAMES, gameId);
  await updateDoc(gameRef, {
    [SUPERLATIVES_FIELD_STATUS]: SUPERLATIVES_STATUS_FINALE,
    [SUPERLATIVES_FIELD_FINALE_SHOWN_AT]: serverTimestamp(),
  });
};

const seedFinaleScenario = async (gameId) => {
  const fn = utils.getCallableFunction(FIREBASE_FUNCTION_SEED_FINALE_SCENARIO);
  const result = await fn({ gameId });
  log.debug("Seeded finale scenario:", result);
  return result;
};

const api = {
  generateSuperlatives,
  getSuperlatives,
  updateSuperlativeIndex,
  markSuperlativesFinale,
  seedFinaleScenario,
};

export default api;
